<div id="container"><p><slot /></p></div>

<style>
	#container {
		text-align: left;
		width: 20vw;
		margin: auto;
	}
	p {
		color: var(--orange);
		font-weight: bold;
		font-size: 1rem;
		font-family: "IBM Plex Mono", monospace;
	}
</style>
